import { Link } from 'react-router-dom';
import { FaLock } from 'react-icons/fa6';
import styles from './DocumentPicker.module.css';

const highlights = [
  {
    id: 'highlight-maine',
    title: 'Built for Maine',
    description: 'Every workflow is crafted with Maine laws, forms, and resources in mind.',
  },
  {
    id: 'highlight-privacy',
    title: 'Privacy first',
    description: 'Your answers stay encrypted and protected—never sold or shared.',
  },
  {
    id: 'highlight-notary',
    title: 'Notary friendly',
    description: 'Step-by-step guidance makes coordinating in-person or remote notarization simple.',
  },
  {
    id: 'highlight-transparent',
    title: 'No surprises',
    description: 'Clear pricing and upfront explanations mean you know exactly what to expect.',
  },
];

const DocumentPicker = () => {
  return (
    <div className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Plan with confidence when it matters most.</h1>
          <p className={styles.heroSubtitle}>
            BedsideDocs walks you through Maine-specific legal documents so you can
            protect loved ones without the paperwork stress.
          </p>
          <div className={styles.heroActions}>
            <Link to="/poa/financial" className={`${styles.button} ${styles.primaryButton}`}>
              Start Financial Power of Attorney
            </Link>
            <a href="#how-it-works" className={`${styles.button} ${styles.secondaryButton}`}>
              Learn More
            </a>
          </div>
        </div>
      </header>

      <main className={styles.mainContent}>
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>Why BedsideDocs</h2>
            <p>Support designed for families navigating urgent decisions.</p>
          </div>
          <div className={styles.highlightGrid}>
            {highlights.map((item) => (
              <article key={item.id} className={styles.highlightCard}>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className={styles.section} aria-label="Security and privacy">
          <div className={styles.securityNote}>
            <span className={styles.securityIcon} aria-hidden="true">
              <FaLock />
            </span>
            <div>
              <h3>Your privacy is our priority</h3>
              <p>
                BedsideDocs uses industry-standard encryption and secure storage so your
                sensitive information never leaves trusted hands.
              </p>
            </div>
          </div>
        </section>
      </main>

      <section className={`${styles.section} ${styles.ctaBannerSection}`} aria-label="Get started">
        <div className={styles.ctaBanner}>
          <div>
            <h2>Ready to get peace of mind?</h2>
            <p>Start your Maine financial power of attorney in minutes.</p>
          </div>
          <Link to="/poa/financial" className={`${styles.button} ${styles.primaryButton}`}>
            Get Started →
          </Link>
        </div>
      </section>
    </div>
  );
};

export default DocumentPicker;
